import React from 'react'
import "../assests/home.css"

function Home() {
  return (
    <>
      <div className="home"> 
      <h1 >
       <span style={{color:'#4D4D4D'}}>
        Don't Fight Alone
        </span> 
        <br/>
        <span style={{color:'#32BAC7'}}>
        We Are Here
        </span>
      </h1>
      </div>
      <div className="homedef">
        Cursus nibh potenti feugiat sed enim suspendisse donec leo. Non blandit egestas metus, duis tellus 
        gravida.Cursus nibh potenti feugiat sed enim suspendisse donec leo.
      </div>
    </>
  )
}

export default Home